import { Button, DialogActions, DialogContent, Grid, Paper, styled } from "@mui/material";
import { Form } from "formik";
import "../personal/ABMnomina/forms/styles/formStyle.css";

export const StyledABMNomina = {
    BreadCrumbContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "15px",
    })),
    GridContainer: styled(Grid)(({ theme }) => ({
        paddingRight: "35px",
        paddingLeft: "35px",
        paddingTop: "15px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        padding: "25px",
    })),
    FormContainer: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
    })),
    InputContainer: styled(Grid)(({ theme }) => ({
        marginBottom: "50px",
    })),
    formMariginTop: {
        marginTop: "50px",
    },
    warningMessageContainer: {
        display: "flex",
        padding: "15px",
        justifyContent: "center",
    },
}

export const StyledDatosDomiciliariosForm = {
    GridContainer: styled(Grid)(({ theme }) => ({
        paddingRight: "35px",
        paddingLeft: "35px",
        paddingTop: "15px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        padding: "25px",
    })),
    FormContainer: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
    })),
    InputContainer: styled(Grid)(({ theme }) => ({
        marginBottom: "50px",
    })),
    FormMarginTop: styled(Form)(({ theme }) => ({
        marginTop: "50px",
    })),
    WarningMessageContainer: styled("div")(({ theme }) => ({
        display: "flex",
        padding: "15px",
        justifyContent: "center",
    })),
}

export const StyledClausula = {
    Container: styled('div')(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
    })),
    LoadingContainer: styled('div')(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        height: "15vh",
    })),
    ContentContainer: styled('div')(({ theme }) => ({
        display: "flex",
        padding: 20,
        // para que en la vista mobile, la seleccion
        // del tipo de clausula quede arriba de
        // la tabla de empresas
        [theme.breakpoints.down(601)]: {
            flexFlow: "column wrap",
            rowGap: "1vh",
        },
    })),
    ClausulasContainer: styled('div')(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "1vw",
    })),
    Button: styled(Button)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        marginBottom: 20,
    })),
};

export const StyledCargaPorTextoForm = {
    Container: styled('div')(({ theme }) => ({
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "75%",
    })),
    Form: styled(Form)(({ theme }) => ({
        display: "inline-flex",
        width: "100%",
    })),
}

export const StyledEmpresaTable = {
    Icons: styled('div')(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        // una separacion minima para que el usuario
        // pueda clickear bien los iconos en mobile
        gap: "1vw",
    })),
    TableFooter: styled('div')(({ theme }) => ({
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        [theme.breakpoints.down(500)]: {
            padding: 5,
        },
    })),
    FormDialogContainer: styled(DialogContent)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        rowGap: "1vw",
    })),
}

export const StyledNominaContainer = {
    Container: styled('div')(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
    })),
    ContentContainer: styled('div')(({ theme }) => ({
        display: "flex",
        padding: 20,
        // para que en la vista mobile, la seleccion
        // de empleados quede arriba de la tabla de nominas
        [theme.breakpoints.down(601)]: {
            flexFlow: "column wrap",
            rowGap: "1vh",
        },
    })),
    ButtonContainer: styled('div')(({ theme }) => ({
        display: "flex",
        justifyContent: "space-evenly",
        padding: 20,
        // para que en la vista mobile, los botones
        // queden uno arriba del otro
        [theme.breakpoints.down(601)]: {
            flexFlow: "column wrap",
            gap: "2vh",
        },
    })),
    Button: styled(Button)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
    })),
    NominaTableContainer: styled('div')(({ theme }) => ({
        display: "flex",
        width: "100%",

        // en la vista de escritorio, si ponemos
        // width: 100%, queda mucho espacio en blanco.
        // pensar que solamente hay 2 columnas en la tabla
        [theme.breakpoints.up(601)]: {
            width: "60%",
        },
    })),
}

export const StyledNominaEmailDialog = {
    Dialog: styled(DialogContent)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",

        [theme.breakpoints.up(600)]: {
            width: "30vw",
            height: "30vh",
            alignItems: "center",
        },
    })),
    Form: styled(Form)(({ theme }) => ({
        display: "flex",
        width: "100%",
        flexFlow: "column wrap",
        rowGap: "5vh",
    })),
    Email: styled('div')(({ theme }) => ({
        display: "flex",
    })),
    Buttons: styled(DialogActions)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
    })),
    ContainerBody: styled(DialogContent)(({ theme }) => ({
        width: 550,
        height: 180,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    FormikInput: styled("div")(({ theme }) => ({
        width: 500,
        marginTop: -50,
    })),
    ContainerButtons: styled(DialogActions)(({ theme }) => ({
        position: "absolute",
        bottom: 10,
        right: 10,
    })),
}

export const StyledNominaTable = {
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        width: "100%",
    })),
}

export const StyledCoberturaViajeAlExterior = {
    Title: styled("p")(({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
        borderBottom: "1px solid green",
        textAlign: "center",
        color: "white",
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        paddingTop: 5,
        paddingBottom: 5,
        marginBottom: 20,
    })),
    BreadcrumbContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: 15,
    })),
    Container: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        margin: "auto"
    })),
    ContentContainer: styled("div")(({ theme }) => ({
        display: "flex",
        padding: 20,
        // para que en la vista mobile, la seleccion
        // de las nominas quede arriba de
        // la tabla de nominas
        [theme.breakpoints.down(601)]: {
            flexFlow: "column wrap",
            gap: "2vh",
        },
    })),
    Dropzone: styled("div")(({ theme }) => ({
        display: "flex",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-evenly",
        padding: 20,
        // para que en la vista mobile, los botones
        // queden uno arriba del otro
        [theme.breakpoints.down(601)]: {
            flexFlow: "column wrap",
            gap: "2vh",
        },
    })),
    Button: styled(Button)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
    })),
    Form: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "3vw",
        padding: 10,
    })),
    DatesInputContainer: styled("div")(({ theme }) => ({
        display: "flex",
        gap: "5vw",
        [theme.breakpoints.down(601)]: {
            flexFlow: "column wrap",
            gap: "1vw",
        },
    })),
    DatePicker: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
    })),
}

export const StyledNominaMasiva = {
    Container: styled(Paper)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        rowGap: "2em",
        borderRadius: 5,
        paddingBottom: 20,
    })),
}

export const StyledNominaMasivaErrorDialog = {
    ContainerBody: styled(DialogContent)(({ theme }) => ({
        width: 550,
        height: 200,
        display: "flex",
    })),
    ContainerButton: styled(DialogActions)(({ theme }) => ({
        position: "absolute",
        bottom: 10,
        right: 10,
    })),
}